import React from "react";
import { useRouter } from "next/router";
import { JhButton } from "designPackages/buttonPackage";
import { RefreshCw, Plus } from "lucide-react";
import LogService from "services/LogService";
import CREDIT_EVENTS from "utils/CreditEvents";
import { handleAddCredits } from "./utils";

interface TransactionHistoryV2MobileBottomActionsProps {
  onRefresh: () => void;
  isLoading?: boolean;
}

const TransactionHistoryV2MobileBottomActions: React.FC<
  TransactionHistoryV2MobileBottomActionsProps
> = ({ onRefresh, isLoading = false }) => {
  const router = useRouter();

  const handleRefresh = () => {
    LogService.log(CREDIT_EVENTS.TH_REFRESH_CLICKED);
    onRefresh();
  };


  return (
    <div id="th-v2-mobile-bottom-actions-container" className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 p-3 z-50">
      <div id="th-v2-mobile-bottom-actions-inner" className="flex items-center gap-2.5">
        {/* Refresh Button */}
        <JhButton
          variant="outline"
          size="default"
          onClick={handleRefresh}
          disabled={isLoading}
          className="flex-1"
        >
          <div id="th-v2-mobile-refresh-button-content" className="flex items-center gap-2">
            <RefreshCw className="w-4 h-4" />
            Refresh
          </div>
        </JhButton>

        {/* Add Credits Button */}
        <JhButton
          variant="default"
          size="default"
          onClick={handleAddCredits(router)}
          disabled={isLoading}
          className="flex-1"
        >
          <div id="th-v2-mobile-add-credits-button-content" className="flex items-center gap-2">
            <Plus className="w-4 h-4" />
            Add Credits
          </div>
        </JhButton>
      </div>
    </div>
  );
};

export default TransactionHistoryV2MobileBottomActions;
